import React from 'react';
import { oohData } from '../utils/oohData';
import { TrendingUpIcon, WrenchIcon } from 'lucide-react';
export const TopStrengthsImprovements: React.FC = () => {
  const {
    topStrengths,
    topImprovements
  } = oohData;
  return <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-240">
      <h2 className="text-lg font-medium text-gray-800 mb-6" data-id="element-241">Key Takeaways</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-242">
        {/* Top Strengths */}
        <div data-id="element-243">
          <div className="flex items-center space-x-3 mb-6" data-id="element-244">
            <div className="p-2 bg-green-100 rounded-lg" data-id="element-245">
              <TrendingUpIcon className="h-5 w-5 text-green-600" data-id="element-246" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-247">
              Top Strengths
            </h3>
          </div>

          <div className="space-y-4" data-id="element-248">
            {topStrengths.map((strength, idx) => <div key={idx} className="bg-green-50/50 p-4 rounded-xl border border-green-100" data-id="element-249">
                <h4 className="text-sm font-bold text-green-800 mb-1" data-id="element-250">
                  {idx + 1}. {strength.name}
                </h4>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-251">
                  {strength.description}
                </p>
              </div>)}
          </div>
        </div>

        {/* Top Improvements */}
        <div data-id="element-252">
          <div className="flex items-center space-x-3 mb-6" data-id="element-253">
            <div className="p-2 bg-amber-100 rounded-lg" data-id="element-254">
              <WrenchIcon className="h-5 w-5 text-amber-600" data-id="element-255" />
            </div>
            <h3 className="text-lg font-semibold text-gray-900" data-id="element-256">
              Top Improvements
            </h3>
          </div>

          <div className="space-y-4" data-id="element-257">
            {topImprovements.map((improvement, idx) => <div key={idx} className="bg-amber-50/50 p-4 rounded-xl border border-amber-100" data-id="element-258">
                <h4 className="text-sm font-bold text-amber-800 mb-1" data-id="element-259">
                  {idx + 1}. {improvement.name}
                </h4>
                <p className="text-sm text-gray-700 leading-relaxed" data-id="element-260">
                  {improvement.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};